module.exports = __webpack_public_path__ + "media/bootstrap-icons/hand-index-thumb-fill-0d79ed48.svg";